import axios from 'axios'
import { baseURL } from './baseUrl'

axios.defaults.withCredentials = true

const axiosInstance = axios.create({
})

axiosInstance.interceptors.request.use(function (config) {
  // const cookies = document.cookie.split(";")
  // const cookie = cookies.filter(item => item.includes('Bearer'))
  config.headers = {
    'Content-Type': 'application/json',
    // 'Authorization': cookie[0]
  }

  return config
})

axiosInstance.defaults.baseURL = baseURL

export default axiosInstance
